<template>
    <LayoutContainer>
        <div id="messages" class="fixed z-40 top-4 right-4">
            <FlashMessage/>
        </div>
        <router-view></router-view>
    </LayoutContainer>
    <Cookie/>
</template>

<script>

import LayoutContainer from "@/components/Layout/LayoutContainer";
import {useStore} from "vuex";

export default {
    components: {LayoutContainer},
    props: {
        initialData: Object
    },
    setup(props) {
        const store = useStore();
        const configuratorData = props.initialData.configurator;
        const productsData = props.initialData.products;
        const orderId = props.initialData.orderId;

        if (configuratorData) {
            if (configuratorData.step) store.dispatch('Step/setStep', configuratorData.step);
            if (configuratorData.products) store.dispatch('ChooseProducts/setChooseProducts', configuratorData.products);
            if (configuratorData.orderData) store.dispatch('OrderData/setOrderData', configuratorData.orderData);
            if (configuratorData.signature) store.dispatch('Signature/setSignature', configuratorData.signature);
        }

        if (productsData) store.dispatch('Products/setProducts', productsData);
        if (orderId) store.dispatch('OrderId/setOrderId', orderId);

        return {
            productsData
        }
    }
};
</script>

